import React from "react";
import { IconContext } from "react-icons";
import { FaRegCheckCircle } from "react-icons/fa";

const Checkmark = props => (
  <IconContext.Provider value={{ className: "react-icons" }}>
    <FaRegCheckCircle />
  </IconContext.Provider>
);

export default Checkmark;
